import { render, staticRenderFns } from "./DropdownButton.vue?vue&type=template&id=461beaab&scoped=true"
import script from "./DropdownButton.vue?vue&type=script&lang=js"
export * from "./DropdownButton.vue?vue&type=script&lang=js"
import style0 from "./DropdownButton.vue?vue&type=style&index=0&id=461beaab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461beaab",
  null
  
)

export default component.exports